import * as React from 'react';
import { Layout, Menu, Row, Col, Icon, Breadcrumb, Button, Avatar, Modal, message, Card, Dropdown } from 'antd';
import '../../css/ViewTest.scss';
import service from '../../service/apolloclient.service';
import LocalStorage from '../../service/localstorage';
import { Link, Redirect } from 'react-router-dom';
import TestView from './TestView';
import ShareTests from './ShareTest';
import { MSGDISPLAYTIME, LOGGEDINUSERTYPE } from '../common/constants';
import TestList from './TestList';
import Print from '../common/print';
import Export from '../common/export';
import Util from '../common/utils';
import CanvasTestView from '../common/canvasTestView';
import TestPdf from './testPdf';
import * as jsPDF from 'jspdf';
import moment from 'moment';
import CustomChart from '../common/CustomChart';
import { BASELINETYPE } from '../common/constants';
import strings from '../../eyeguide-localization/test/string.test.view';
import stringsmain from '../../eyeguide-localization/strings.main';
import cstrings from '../../eyeguide-localization/strings.common';
import Token from '../common/token';
import { Tasks } from '../common/auth';
import Auth from '../common/auth';
import 'moment/locale/es';

var docx = new jsPDF({
    orientation: 'landscape',
    unit: 'pt',
    format: 'letter',
});
const userIcon = require('../../images/illustration-profile.png');
const { Header, Content } = Layout;
const logow = require('../../images/logo.png');
const SubMenu = Menu.SubMenu;
const storage = new LocalStorage();

const VIEWSTATE = {
    LOGOUT: 'logout',
};

interface IViewTestProp {
    match: any;
    location: any;
}

interface IViewTestState {
    collapsed: boolean;
    organization: string;
    isTestView: boolean;
    orgName: string;
    profileName: string;
    testName: string;
    testHistory: any;
    testResult: any;
    baselineTestData: any;
    shareModalVisible: boolean;
    shareUsers: any;
    sharetests: any;
    exportModalVisisble: any;
    sharetestsList: any;
    isRTAShare: boolean;
    isExternal: boolean;
    isOldData: boolean;
    isOldDataBaseline: boolean;
    selectedKey: any;
    loading: boolean;
    testViewLoading: boolean;
    emptyText: string;
    shareId: any;
    shareUserId: string;
    isVisualOnly: boolean;
}

export default class ViewTest extends React.Component<IViewTestProp, IViewTestState> {
    profileMenu: any;
    showRTA: boolean = false;
    downloadMenu: any;
    menu = (
        <Menu onClick={() => ''}>
          <Menu.Item key="1">{strings.lsCSVTxt}</Menu.Item>
        </Menu>
    );
    iframe: HTMLIFrameElement | null;
    jframe: HTMLIFrameElement | null;
    constructor(props: IViewTestProp) {
        super(props);
        this.state = {
            collapsed: false,
            organization: '',
            // isTestView: props.match.params.rta === 'enableRta' ? false : true,
            isTestView: true,
            orgName: '',
            profileName: '',
            testName: '',
            testHistory: [],
            testResult: [],
            baselineTestData: [],
            shareModalVisible: false,
            shareUsers: [],
            sharetests: [],
            exportModalVisisble: false,
            sharetestsList: [],
            isRTAShare: false,
            isExternal: storage.getUser() === LOGGEDINUSERTYPE.ExternalUser.toString() ? 
                            true : false ,
            isOldData: false,
            isOldDataBaseline: false,
            selectedKey: '',
            loading: true,
            emptyText: '',
            shareId: '',
            shareUserId: '',
            testViewLoading: true,
            isVisualOnly: false
        };
        this.showShareTest = this.showShareTest.bind(this);   
        this.setShareModalVisible = this.setShareModalVisible.bind(this);
        this.shareTests = this.shareTests.bind(this);
        this.showShareTestForRTA = this.showShareTestForRTA.bind(this);
        this.setShareTests = this.setShareTests.bind(this);      
        this.showShareTestList = this.showShareTestList.bind(this);
        this.notifyTestDownload = this.notifyTestDownload.bind(this);
        this.createPDF = this.createPDF.bind(this);        
        this.profileMenu = (
            <Menu mode="inline">
              <Menu.Item>
                  <Link to={'/settings'}>
                  <Icon type="setting" />
                      <span> {strings.lsSettingsTxt}</span>
                  </Link>  
              </Menu.Item>
              <Menu.Item key={VIEWSTATE.LOGOUT}>
                  <Link to={'/login'}>
                  <Icon type="logout" />
                      <span> {strings.lsLogOutTxt}</span>
                  </Link>           
              </Menu.Item>
          </Menu>
        );

        this.downloadMenu = (
            <Menu 
                onClick={(e) => {
                    TestPdf({
                        index: 0,
                        state: this.state,
                        doc: docx,
                        isLast: true,
                        singleTest: true,
                        setCanvas: (filename) => this.setTestCanvas(filename),
                        notifyDownload: () => this.notifyTestDownload()
                    });
                    this.setState({
                        isVisualOnly: e.key === strings.lsDownloadVisualOnly ? true : false
                    });
                }}
            >              
                <Menu.Item key={strings.lsDownloadTestTxt}>
                        {strings.lsDownloadTestTxt}
                </Menu.Item>
                <Menu.Item key={strings.lsDownloadVisualOnly}>{strings.lsDownloadVisualOnly}</Menu.Item>              
            </Menu>
        );
    }

    async componentDidMount() {
        document.title = 'EyeGuide';
        strings.setLanguage(navigator.language);
        let token = this.decodeToken(storage.getToken());
        console.log('view test token', token);
        console.log('componentDidMount', this.props.match.params.testid);
        console.log(storage.getUser());

        // let isTestView = this.props.match.params.rta === 'enableRta' ? false : true;
        // above line is used for showing rta if url contains enableRta
        let isTestView = true;
        let testResult = await this.getTestDetails(this.props.match.params.testid, 0);
        let testHistory: any;
        this.state.isExternal && isTestView ? testHistory = [] : 
                testHistory = await this.getTestHistory(testResult.playerid, testResult.testtimestamp);
        let baselineTestData: any;
        // let baseline = this.findBaselineTest(testHistory);
        if (testResult.baseline === 1) {
            baselineTestData = testResult;
            console.log('in baseline');
        } else {
            baselineTestData = await this.getTestDetails(this.props.match.params.testid, 1);
        }
        console.log('testHistory', testHistory);
        console.log('testResult', testResult);
        console.log('baselineTestData', baselineTestData);
        this.setState({
            // isExternal,
            profileName: testResult.athlete.firstname + ' ' + testResult.athlete.lastname,
            orgName: testResult.athlete.organizationname,
            testName: this.getTestNameWithDate(testResult),
            testHistory,
            testResult,
            organization: storage.getOrganizationName(),
            baselineTestData,
            isOldData: testResult.calibaratedtestcoords === null ? true : false,
            isOldDataBaseline: baselineTestData.calibaratedtestcoords === null ? true : false,
            loading: false,
            emptyText: testHistory.length === 0 ? 'No data' : '',
            isTestView: isTestView,
            isRTAShare: !isTestView,
            selectedKey: isTestView ? testResult.testid : '3', // 3 for return to activity
            shareId: token !== undefined && token.shareid !== undefined ? token.shareid : '',
            shareUserId: token !== undefined && token.shareuserid !== undefined ? token.shareuserid : '',
            testViewLoading: false
        });
    }

    async componentWillReceiveProps(nextProps: any) {

        console.log('componentWillReceiveProps', nextProps.match.params.testid);
        console.log(storage.getUser());
        if ( (this.props.match.params.testid !== nextProps.match.params.testid && 
            (this.props.match.params.rta !== nextProps.match.params.rta || 
                nextProps.match.params.rta !== undefined)) ||
            (this.props.match.params.testid === nextProps.match.params.testid && 
                this.props.match.params.rta !== undefined && nextProps.match.params.rta === undefined )) {
            // let isTestView = nextProps.match.params.rta === 'enableRta' ? false : true;
            // above line is used for showing rta if url contains enableRta
            let isTestView = true;
            let testResult = await this.getTestDetails(nextProps.match.params.testid, 0);
            let testHistory: any;
            this.state.isExternal && isTestView ? testHistory = [] : 
                    testHistory = await this.getTestHistory(testResult.playerid, testResult.testtimestamp);
            let baselineTestData: any;
            // let baseline = this.findBaselineTest(testHistory);
            if (testResult.baseline === 1) {
                baselineTestData = testResult;
                console.log('in baseline');
            } else {
                baselineTestData = await this.getTestDetails(nextProps.match.params.testid, 1);
            }
            console.log('testHistory', testHistory);
            console.log('testResult', testResult);
            console.log('baselineTestData', baselineTestData);
            this.setState({
                // isExternal,
                profileName: testResult.athlete.firstname + ' ' + testResult.athlete.lastname,
                orgName: testResult.athlete.organizationname,
                testName: this.getTestNameWithDate(testResult),
                testHistory,
                testResult,
                organization: storage.getOrganizationName(),
                baselineTestData,
                isOldData: testResult.calibaratedtestcoords === null ? true : false,
                isOldDataBaseline: baselineTestData.calibaratedtestcoords === null ? true : false,
                loading: false,
                emptyText: testHistory.length === 0 ? 'No data' : '',
                isTestView: isTestView,
                isRTAShare: !isTestView,
                selectedKey: isTestView ? testResult.testid : '3', // 3 for return to activity
                testViewLoading: false
            });
            Util.resetScroll();
            window.scrollTo(0, 0);
        }
    }
    
    /*openHelpCenter = () => { // open helpcenter in new tab
        return window.open('/zendesklogin', '_blank');
    }*/
      
    render() {
        let isFocusUser = Auth.canPerformTask(parseInt(Token.decodeToken().roleid, 10), Tasks.isFocusUser); 
        let orgName = isFocusUser ? stringsmain.lsEyeGuideTxt : storage.getOrganizationName();
        let userName = storage.getFirstName() + ' ' + storage.getLastName();
        console.log('storage.getOrganizationName()', storage.getOrganizationName());
        console.log('this.state.testResult', this.state.testResult);
        console.log('this.state.testResult.athelete', this.state.testResult.athlete);
        let rosterid  = this.state.testResult !== undefined && 
                this.state.testResult.athlete !== undefined ? 
                    this.state.testResult.athlete.rosterid : 0;
        console.log('rosterid', rosterid);
        let isExternalLogin = parseInt(storage.getUser(), 10) === LOGGEDINUSERTYPE.ExternalUser ? true : false;
        let token = storage.getToken();
        console.log('storage.getSelectedOrg()', typeof(storage.getSelectedOrg()));
        console.log('storage', storage.getSelectedOrg() !== '' ? storage.getSelectedOrg().toString().split(',')
                  : storage.getSelectedOrg());
        if (token.length === 0 || ( token.length > 0 && !this.tokenIsValid(isExternalLogin, token))
        ) {
          if (isExternalLogin) {
            return(
                    <Redirect 
                        to={'/external/login/' + this.props.match.params.shareuserid + '/' + 
                              this.props.match.params.shareid}
                    /> 
                );
          } else { return ( <Redirect to="/login" /> ); }
        }
        let {testinfo, testtag} = this.state.testResult;
        return(
            <div  className="ViewTest">
             <Layout id="layout">
                <Header className="header">
                <div className="logo" />
                <div className="logoContainer">
                <div className="logoD"> 
                    <Row className="headerCols">
                        <Col xs={1} sm={1} md={2} lg={5} xl={4}>
                            <img className={this.state.collapsed ? 'logoS' : 'logoB'} src={logow} />
                        </Col>
                        { this.state.isExternal ?  '' :
                        <div>
                        <Col xs={1} sm={1} md={2} lg={8} xl={15}>
                        
                            <Menu
                                theme="dark"
                                mode="horizontal"
                                defaultSelectedKeys={[this.state.selectedKey]}
                                selectedKeys={[this.state.selectedKey]}
                                style={{ lineHeight: '64px' }}
                                onClick={e => this.changeView(e)} 

                            >
                                <Menu.Item key="1">
                                    <Link to={'/profile/view/' + this.state.testResult.playerid}>
                                    <Icon type="left" />
                                        {strings.lsBackToProfileTxt} 
                                    </Link>
                                </Menu.Item>
                                {/* <Menu.Item >Test History</Menu.Item> */}
                                <SubMenu 
                                    popupOffset={[0, 0]} 
                                    title={<span>{strings.lsTestHistory}</span>}
                                    key="2"
                                >
                                    { this.state.testHistory.map((e: any) => (
                                            <Menu.Item key={e.testid}>
                                                {this.getTestNameWithDate(e)}
                                            </Menu.Item>
                                        )
                                    )}
                                </SubMenu>
                             {this.showRTA ? this.checkIfTestConcussed() ?   
                                        <Menu.Item key="3">
                                            <Link 
                                                to={'/viewtest/' + this.props.match.params.testid
                                                    + '/enableRta'}
                                            >
                                                {strings.lsReturnToActivityTxt}
                                            </Link>
                                        </Menu.Item> : '' : ''}
                            </Menu> 
                       
                        </Col>
                        {/* <Col xs={1} sm={1} md={2} lg={8} xl={5}> */}
                        <div className="avatar">
                            <Dropdown className="userMenu" overlay={this.profileMenu} placement="bottomRight">
                            <div>
                                    <Avatar 
                                        src={userIcon}
                                        style={{ backgroundColor: '#8B9FB2' }} 
                                        icon="user" 
                                    />
                                    <div className="hDisplayName" >
                                        <div>{userName}
                                        </div>

                                    </div> 
                                    <div 
                                        className="hOrgName"                      
                                        title={orgName}                
                                    >{'  ' + orgName}
                                    </div>
                                </div>
                            </Dropdown>
                        </div> 
                        {/* <Icon 
                            className="zendeskHelp"
                            type="question-circle"
                            onClick={() => { return this.openHelpCenter(); }}
                        /> */}
                        {/* </Col> */}
                        </div>
                         }
                    </Row>
                    </div>
                </div>
                    <Row className="btnRow">
                        <Col xs={1} sm={1} md={2} lg={16} xl={16}>
                       {this.state.isExternal ? 
                        <Breadcrumb> 
                                <Breadcrumb.Item>
                                    <a 
                                        href={'/external/home/' + this.state.shareUserId
                                        + '/' + this.state.shareId} 
                                    >
                                        {strings.lsSharedDataTxt}
                                    </a>
                                </Breadcrumb.Item>
                                <Breadcrumb.Item>
                                    {   
                                        this.state.isTestView ?
                                        this.state.profileName 
                                        + ' - ' 
                                        + this.state.testName 
                                        + ' - ' 
                                        + (testtag ? `(${strings.lsTestTagTxt}: ${testtag.toUpperCase()})` : '')
                                        : strings.lsReturnToActivityTxt
                                    }
                                </Breadcrumb.Item>
                            </Breadcrumb> :
                            <Breadcrumb> 
                                <Breadcrumb.Item><a href="/dashboard">{strings.lsHomeTxt}</a></Breadcrumb.Item>
                                <Breadcrumb.Item>
                                    <a href={'/profile/' + rosterid}>
                                        {this.state.orgName + ' ' + strings.lsProfilesTxt}
                                    </a>
                                </Breadcrumb.Item>
                                <Breadcrumb.Item>
                                <a href={'/profile/view/' + this.state.testResult.playerid}>
                                    {this.state.profileName}
                                </a>
                                </Breadcrumb.Item>
                                <Breadcrumb.Item>{ this.state.isTestView ? this.state.testName 
                                        + ' - ' 
                                        + (testinfo ? testinfo.length ? '(eye: LEFT)' : '(eye: RIGHT)' : '') 
                                        + ' - ' 
                                        + (testtag ? `(${strings.lsTestTagTxt}: ${testtag.toUpperCase()})` : '')
                                        : strings.lsReturnToActivityTxt}</Breadcrumb.Item>
                            </Breadcrumb>}
                        </Col>
                        <Col xs={1} sm={1} md={2} lg={8} xl={8}>
                           { this.state.isTestView ? 
                           <div>
                                <Dropdown 
                                    trigger={['click']}
                                    overlay={this.downloadMenu}
                                    getPopupContainer={this.getContainer}
                                >
                                    <Button 
                                        className="btn" 
                                        icon="download" 
                                        type="primary"
                                        onClick={() => console.log('download menu clicked')}
                                    >
                                    {strings.lsDownloadTestTxt} 
                                    </Button>
                                </Dropdown>
                            {this.state.isExternal ? '' : <Button 
                                className="btn btnShare" 
                                icon="right" 
                                type="primary"
                                onClick={e => this.showShareTest()}
                            > {strings.lsShareTestTxt} 
                            </Button> }
                            </div> : 
                            this.state.isExternal ? '' :
                            <Button 
                                className="btn btnShare" 
                                icon="right" 
                                type="primary"
                                onClick={e => this.showShareTestForRTA()}
                            > {strings.lsShareReturnToActivityTxt} 
                            </Button> 
                        }
                        </Col>
                    </Row>

            </Header>
            <Content className="content">
                { this.state.isTestView ? 
                <TestView
                    width={1024}
                    height={768}
                    baselinedata={this.getCoords(this.state.baselineTestData)}
                    testdata={this.getCoords(this.state.testResult)}
                    stimulusRequired={this.isBaselineTest()}
                    isTestImpaired={this.checkIfTestsIsImpaired()}
                    testText={Util.getLocalizedTestType(this.state.testResult.range)}
                    testScore={Util.formatNumber(this.state.testResult.score, 2)}
                    isOldData={this.state.isOldData}
                    isOldDataBaseline={this.state.isOldDataBaseline}
                    loading={this.state.testViewLoading}
                />
                :
                <div 
                    style={{paddingLeft: '110px',
                             paddingRight: '20px'}}
                >
                {/* <span> Return to activity </span>  */}
                <CustomChart 
                    height={768} 
                    width={1024}
                    data={this.getTestsScoreData()} 
                    datalabels={this.getdatalabels()}
                    yRangelabels={[strings.lsVSPTxt, strings.lsSUPTxt, strings.lsHAVTxt, strings.lsAVGTxt
                        , strings.lsLAVTxt, strings.lsBDLTxt, strings.lsMDITxt, strings.lsMOITxt, strings.lsSVITxt]}
                    yLabelText={[strings.lsVerySuperiorTxt, 
                                strings.lsSuperiorTxt, 
                                strings.lsHighAverageTxt, 
                                strings.lsAverageTxt, 
                                strings.lsLowAverageTxt, 
                                strings.lsBorderlineTxt, 
                                strings.lsMildlyImpairedTxt, 
                                strings.lsModeratelyImpairedTxt,
                                strings.lsSeverlyImpairedTxt]}
                    dataText={[]}
                    yRangeValues={[ 0, 8390.9, 15269.7, 22148.4, 34923.2, 41801.9, 47698.0, 53594.0, 57524.7 ]}
                    yMax={250000}
                    xLabels={this.getDateLabels()} 
                    baselineScore={this.getBaselineScore()}
                />  
                <Card className="cardFont" title={strings.lsReturnToActivTestHisTxt} style={{ margin: '24px 16px' }}>
                   { this.state.isExternal ? '' : 
                    <Button 
                        icon="right" 
                        type="primary" 
                        style={{marginBottom: 20 }} 
                        disabled={this.state.sharetests.length === 0}
                        onClick={e => this.showShareTestList()}
                    > {strings.lsShareTestTxt}
                    </Button>
                   }
                    <Button 
                        style={{marginLeft: 10, marginBottom: 20 }}
                        onClick={() => this.printList()}
                    >{strings.lsPrintTxt}
                    </Button>  
                    <iframe 
                        style={{height: 0, width: 0, border: 'none'}} 
                        ref={el => this.iframe = el} 
                    />  

                    <Button 
                            style={{marginLeft: 10, marginBottom: 20 }}
                            onClick={() => this.exportFile()}
                    >{strings.lsDownloadTxt}
                    </Button>
                    <Modal
                        title={strings.lsExportProfileTxt}
                        visible={this.state.exportModalVisisble}
                        onOk={() => this.setState({exportModalVisisble: false})}
                        okText={strings.lsOkTxt}
                        width={350}
                        bodyStyle={{padding: 0 }}
                        maskClosable={false}
                        closable={false}
                        footer={[
                            <Button 
                                    key="Ok" 
                                    type="primary"  
                                    onClick={() => this.setState({exportModalVisisble: false})}
                            >
                            {strings.lsOkTxt}
                            </Button>,
                        ]}
                    >
                        <Row style={{padding: '19px'}}>
                            {strings.lsTestExportSuccessTxt}
                        </Row>
                    </Modal>
                    <TestList 
                        organizationID={''} 
                        rosterID={''} 
                        tests={this.state.testHistory !== undefined ? this.state.testHistory.length > 0 ?
                                        this.state.testHistory : [] : []}
                        notifySelectedTests={this.state.isExternal ? undefined : this.setShareTests}
                        organizationName={''}
                        enableTitleSpace={''}
                        pagination={true}
                        sorting={true}
                        showAthelete={false}
                        showDownloadAction={true}
                        loading={this.state.loading}
                        emptyText={this.state.emptyText}
                        showEditAction={false}
                        notifyTestUpdated={undefined}
                    />
                </Card>
                </div>
            }
            </Content>
            </Layout>
            <Modal
                className="modal"
                title={strings.lsShareTestTxt}
                visible={this.state.shareModalVisible}
                okText={strings.lsShareTxt}
                onOk={() => this.setShareModalVisible(1)}
                onCancel={() => this.setShareModalVisible(0)}
                width={800}
                maskClosable={false}
                closable={false}
            >
                <ShareTests
                    sharedTests={this.state.sharetests}
                    notifyUsers={this.shareTests}
                    isOpen={this.state.shareModalVisible}
                />
            </Modal>
          </div>
        );
    }

    private async changeView(e: any) {
        console.log('chnageView', e);
        if (e.key === '3') {
            this.setState({
                isTestView: false,
                selectedKey: '3'
            });
        } else if (e.key === '1') {
            console.log('back to profile clicked');
        } else {
            console.log(this.props.match.location);
            window.location.href = '/viewTest/' + e.key;
            // let testResult = await this.getTestDetails(e.key, 0);
            // this.setState({
            //     testResult,
            //     testName: this.getTestNameWithDate(testResult),
            //     isTestView: true,
            //     selectedKey: e.key
            // });
        }
    }

    private async getTestDetails(testid: string, baseline: number) {
        let ser = new service();
        let data = await ser.getTestResults(testid, baseline);
        console.log('test results', data);
        return data[0];
    }

    private async getTestHistory(playerid: string, time: string) {
        console.log('getTestHistory');
        let ser = new service();
        let tests = await ser.getTestsAfterLastBaseline(playerid, time);
        console.log('tests', tests);
        return tests;
    }

    private getTestNameWithDate(element: any) {
        return element.baseline !== 1 ? 
            element.testtag 
            + ' - ' 
            + Util.getLocalizedTestType(element.range) 
            + ' (' + Util.getDate(element.testtimestamp) + ')' : 
            BASELINETYPE.BASELINE + ' (' + Util.getDate(element.testtimestamp) + ')' 
            + (element.bestbaseline === true && element.baseline === 1 ? ' (best)' : '');
    }

    // private findBaselineTest(testHistory: any) {
    //     let baseline = testHistory.filter((e: any) => 
    //         e.baseline === 1
    //     );
    //     console.log('baseline', baseline);
    //     return baseline[0];
    // } 
    
    private checkIfTestsIsImpaired() {
       console.log('checkIfTestsIsImpaired', 
                   this.state.testResult.range !== undefined ?
                   this.state.testResult.range.indexOf(strings.lsMildlyImpairedTxt) !== -1 : false);
       return this.state.testResult.range !== undefined ? 
       this.state.testResult.range.indexOf(strings.lsMildlyImpairedTxt) !== -1 : false;
    }

    private isBaselineTest() {
        return this.state.testResult.baseline === 1;
    }

    private formatCorrds(coords: any) {
        console.log('formatCorrds', coords);
        if (coords !== undefined) {
            let data = coords;
            let formattedData: any = [];
            data.forEach((e: any) => {
                formattedData.push({x: e.eye_x, y: e.eye_y});
            });
            console.log('formattedData', formattedData);
            return formattedData;
        }
    }

    // private formatScore(score: number) {
    //     if (score !== undefined) {
    //         return score.toFixed(3);
    //     } else {
    //         return '0';
    //     }

    // }

    private checkIfTestConcussed() {
        let tests: any = this.state.testHistory.filter((e: any) => 
            e.concussed === true
        );
        return tests.length > 0 ? true : false;
    }

    private showShareTest() {
        this.setState({
            sharetests: [this.state.testResult.testid],
            shareModalVisible: true
        });
    }

    private showShareTestList() {
        this.setState({
            shareModalVisible: true
        });
    }

    private showShareTestForRTA() {
        this.setState({
            sharetests: this.getTestIds(this.state.testHistory),
            shareModalVisible: true,
            isRTAShare: true
        });
    }

    private shareTests(shareUsers: any) {
        this.setState({
            shareUsers
        });
        console.log('shareTests', shareUsers);
    }

    private async setShareModalVisible(event: number) {
        if (event === 1) { // share
            let testids = this.state.sharetests;
            let input: any = [];
            console.log('modalVisible share users', this.state.shareUsers);
            if (this.state.shareUsers.length > 0) {
                this.state.shareUsers.forEach((element: any) => {
                    input.push({firstname: element.fname, lastname: element.lname,
                        email: element.email, phone: element.phone});
                });
                console.log('input to create', input);
                console.log('testids to create', testids);
                this.setState({ sharetests: [], shareUsers: [] });
                let ser = new service();
                let response: any;
                if (this.state.isRTAShare) {
                    console.log('RTA Share');
                    response = await ser.createSharedTest(testids, 1, input);
                } else {
                    console.log('Normal Share');
                    response = await ser.createSharedTest(testids, 0, input);
                }
                console.log('create response', response);
                if (response.status === 0) {
                    message.success(strings.lsTestSharedSuccessTxt, MSGDISPLAYTIME);
                } else {
                    message.error(strings.lsTestSharedFailedTxt, MSGDISPLAYTIME);
                }
            } else {
                return;
            }

        }
        this.setState({
            shareModalVisible: false,
            isRTAShare: false
        });
        console.log('number');
    }

    private getTestIds(tests: any) {
        let testids: any =  [];
        tests.forEach((e: any) => {
            testids.push(e.testid);
        });
        return testids;
    }
    
    private printList() {
        console.log('profilesFromPrint', this.state.testHistory);
        let buildData: any;
        buildData = this.buildTestData(this.state.testHistory);
        if (buildData.length > 0) {
            Print.printContents(buildData, strings.lsTestsTxt, this.iframe);
        }
    }

    private exportFile() {
        console.log('profilesFromPrint', this.state.testHistory);
        let buildData: any;
        buildData = this.buildTestData(this.state.testHistory);
        if (buildData.length > 0) {
            Export.exportCSVFile(buildData, strings.lsTestsTxt);
            this.setState({exportModalVisisble: true});
        }
    }

    private buildTestData(tests: Array<any>) {
        let columnData: Array<any> = [];
        tests.forEach( (element: any) => {
            let data = {
                name: element.athlete.firstname + ' ' + element.athlete.lastname,
                date_and_time: Util.getDate(element.testtimestamp) + ' ' + Util.getTime(element.testtimestamp),
                test_type:  (element.baseline === 1 ? BASELINETYPE.BASELINE : 
                            Util.getLocalizedTestType(element.range) ) 
                            + (element.bestbaseline === true && element.baseline === 1 ? ' (best)' : '') ,
                // dr_dx_concussion: Util.getConcussed(element.concussed),
                score: element.score,
            };
            columnData.push(data);
        }); 
        return columnData;
    }

    private setShareTests(testlist: Array<any>) {
        this.setState({
            sharetests: testlist
        });
    }

    private async notifyTestDownload() {
        docx = new jsPDF({
            orientation: 'landscape',
            unit: 'pt',
            format: 'letter',
        });
    }

    private setTestCanvas = async (filename) => {
        console.log('downloadTest: ', this.state.testResult);
        let canvas: any = document.createElement('canvas');
        canvas.width = 1024;
        canvas.height = 768;
        let canvasView = new CanvasTestView(
            canvas, this.getCoords(this.state.baselineTestData),
            this.getCoords(this.state.testResult),
            this.isBaselineTest(), this.checkIfTestsIsImpaired(), 
            Util.getLocalizedTestType(this.state.testResult.range), 
            Util.formatNumber(this.state.testResult.score, 2), 
            this.state.isOldData, this.state.isOldDataBaseline,
            this.state.isVisualOnly
        );
        await canvasView.setCanvasView();
        let isExternalLogin = parseInt(storage.getUser(), 10) === LOGGEDINUSERTYPE.ExternalUser ? true : false;
        if (!isExternalLogin) {
            let ser = new service();
            let athlete = JSON.parse(JSON.stringify(this.state.testResult.athlete));
            athlete.playerid = this.state.testResult.playerid;
            await ser.testDownloaded(JSON.stringify(athlete));
        }
        let img = new Image();
        img.src = canvas.toDataURL();
        img.width = 1024 * 0.5;
        img.height = 768 * 0.5;
        if (this.state.isVisualOnly) {
            setTimeout(() => { this.canvasToImage(canvas, filename); }, 500);
        }
        return img;
    }

    private getCoords(data: any) {
        return  this.formatCorrds( 
            data.calibaratedtestcoords === null ? 
                data.testcoords : data.calibaratedtestcoords);
    }

    private createPDF(canvas: any) {

        const logo = require('../../images/logo_black.png');
        // const font = require('../images/sf-pro-text-heavy.woff');
        let doc = new jsPDF({
            orientation: 'landscape',
            unit: 'pt',
            format: 'letter',
        });
        // Page 1
        // Logo
        doc.addImage(logo, 'PNG', 48, 64, 276 , 55);
        // Labels
        doc.setFont('Helvetica', 'normal');
        doc.setFontSize(12);
        doc.text(cstrings.lsName + ':', 48, 320);
        doc.text(cstrings.lsProvidedByTxt + ':', 48, 405);
        doc.text(cstrings.lsDateTimeDownloadTxt + ':', 48, 490);
        // Data
        doc.setFont('Helvetica', 'bold');
        doc.setFontSize(16);
        doc.text(this.state.profileName, 48, 343); // Player

        doc.text(this.state.orgName, 48, 428); // Organization Name

        let currdate = new Date().toISOString();
        moment.locale(navigator.language);
        console.log('moment date', moment(currdate).format('DD MMMM YYYY [@] h[:]mm[:]ss A')); 
        doc.text(moment(currdate).format('DD MMMM YYYY [@] h[:]mm[:]ss A'), 48, 513); // Downloaded date time
        this.addDisclaimer(doc);
        // Page 2
        doc.addPage();
        // label
        doc.setFont('Helvetica', 'normal');

        doc.setFontSize(12);

        doc.text(cstrings.lsName + ':', 64, 35);

        // NOTE: Will need to change Baseline to Test if test is not baseline
        let testType = this.state.testResult.baseline === 1 ? BASELINETYPE.BASELINE : BASELINETYPE.TEST;
        doc.text(cstrings.lsFocusTxt + ' ' +  testType  + ' ' + cstrings.lsDateAndTimeTxt + ':', 728, 35, 'right');

        // Data
        doc.setFont('Helvetica', 'bold');

        doc.setFontSize(16);

        doc.text(this.state.profileName, 64, 58); // Player

        let testDate = new Date(this.state.testResult.testtimestamp).toISOString();
        moment.locale(navigator.language);
        doc.text(moment(testDate).format('DD MMMM YYYY [@] h[:]mm[:]ss A'), 728, 58, 'right');  // Test date time

        // image
        doc.addImage(canvas.toDataURL(), 66, 66, 664, 498);
        // medical disclaimer
        this.addDisclaimer(doc);
        // Page 3

        /*doc.addPage();

        doc.text(cstrings.lsEyeGuideInfoTxt, 278, 234);

        doc.setFontSize(20);

        doc.text(cstrings.lsPlaceholderForTxt + ':', 21, 55);*/

        // doc.save(this.state.profileName + '.pdf');
        let filename = Util.getRandomAlphaNum();
        doc.save(filename + '.pdf');
        if (this.state.isVisualOnly) {
            setTimeout(() => { this.canvasToImage(canvas, filename); }, 500);
        }

        return '';
    }
    
    private addDisclaimer(pdf: any) {
        pdf.setFont('Helvetica', 'normal');
        pdf.setFontSize(8);
        var pageHeight = pdf.internal.pageSize.height || pdf.internal.pageSize.getHeight();
        var pageWidth = pdf.internal.pageSize.width || pdf.internal.pageSize.getWidth();
        var disclaimerTxt = strings.lsDisclaimerTxt + ' : ' + strings.lsDisclaimerInfoTxt;
        var splitTxt = pdf.splitTextToSize(disclaimerTxt, pageWidth - 70);
        var y = 8;
        for (var k = 0; k < splitTxt.length; k++) {                             
            pdf.text(splitTxt[k], pageWidth / 2, (pageHeight + y)  - 35, 'center');
            y = y + 8;
        }
    }

    private getTestsScoreData() {
        console.log('getTestsScoreData', this.state.testHistory);
        let data = this.state.testHistory;
        let scores: any = [];
        data.forEach((e: any) => {
            if (e.baseline !== 1) {
                scores.push(Util.formatNumber(e.score, 2));
            }
        });
        console.log('scores', scores);
        return scores;
    }

    private getdatalabels() {
        let data = this.state.testHistory;
        let dataLabels: any = [];
        moment.locale(navigator.language);
        data.forEach((e: any) => {
            if (e.baseline !== 1) {
                dataLabels.push(strings.lsTestTxt + ' (' + Util.formatNumber(e.score, 2) + ', ' + e.range + ')\n' 
                + moment(e.testtimestamp).format('MMMM DD[,] YYYY[,] h[:]mm A') );
            }
        });
        console.log('dataLabels', dataLabels);
        return dataLabels;
    }
    private getDateLabels() {
        let data = this.state.testHistory;
        let dateLabels: any = [];
        moment.locale(navigator.language);
        data.forEach((e: any) => {
            if (e.baseline !== 1) {
                dateLabels.push(moment(e.testtimestamp).format('DD[\n]MMM[\n]YYYY') );
            }
        });
        return dateLabels;
    }

    private getBaselineScore() {
        return this.state.baselineTestData.score;
    }

    private decodeToken(token: any) {
        if (token !== undefined) {
          let base64Url = token.split('.')[1];   
          let base64 = base64Url.replace('-', '+').replace('_', '/');
          return JSON.parse(window.atob(base64));
        }
    }

    private tokenIsValid(isExternal: boolean, token: any) {
        let decodedToken: any = this.decodeToken(token) ;
        if ( isExternal && decodedToken.user === LOGGEDINUSERTYPE.ExternalUser) {
          return true;
        } else if ( !isExternal && decodedToken.user === LOGGEDINUSERTYPE.InternaleUser) {
          return true;
        } else {
          return false;
        }
    }

    private canvasToImage(canvas: any, filename: string) {  
        
        if (canvas.msToBlob) { // for IE
            console.log('msToBlob');
            var blob = canvas.msToBlob();
            window.navigator.msSaveBlob(blob, filename + '.png');
        } else {
            console.log('canvasToImage');
            var dataURL = canvas.toDataURL('image/png').replace('image/png', 'image/octet-stream');        
            let a = document.createElement('a');
            a.href = dataURL;
            a.download = filename + '.png';
            document.body.appendChild(a);            
            a.click();
            a.remove();
        }               
    }

    private getContainer = (triggernode) => {
        // debugger;
        return triggernode.parentNode;
    }

}



// WEBPACK FOOTER //
// ./src/components/test/ViewTest.tsx